import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiGithub, FiLinkedin } from 'react-icons/fi';
import './Home.css';
import API_URL from '../config';

const Home = () => {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch(`${API_URL}/profile/info`);
        const data = await res.json();
        if (data.success) setProfile(data.data);
      } catch (error) {
        console.error('Failed to fetch profile');
      }
    };
    fetchProfile();
  }, []);

  const name = profile?.name || 'Manish Mandal';
  const title = profile?.title || 'Backend Developer';
  const bio = profile?.bio || 'I build server-side apps using Node.js, Express, and MongoDB.';
  const github = profile?.github || 'https://github.com/manishmandal55';
  const linkedin = profile?.linkedin || 'https://linkedin.com/in/manishmandal55';
  const location = profile?.location || 'Hetauda, Nepal';

  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-greeting animate-fade-in">
            <span className="greeting-line"></span>
            <span>Hello, I'm</span>
          </div>
          
          <h1 className="hero-title animate-fade-in" style={{ animationDelay: '0.1s' }}>{name}</h1>
          
          <h2 className="hero-subtitle animate-fade-in" style={{ animationDelay: '0.2s' }}>
            <span className="typing-text">{title}</span>
          </h2>
          
          <p className="hero-description animate-fade-in" style={{ animationDelay: '0.3s' }}>{bio}</p>
          
          <div className="hero-buttons animate-fade-in" style={{ animationDelay: '0.4s' }}>
            <Link to="/projects" className="btn btn-primary">View Projects <FiArrowRight /></Link>
            <Link to="/contact" className="btn btn-outline">Get in Touch</Link>
          </div>
          
          <div className="hero-social animate-fade-in" style={{ animationDelay: '0.5s' }}>
            <a href={github} target="_blank" rel="noopener noreferrer" className="social-icon"><FiGithub /></a>
            <a href={linkedin} target="_blank" rel="noopener noreferrer" className="social-icon"><FiLinkedin /></a>
          </div>
        </div>
        
        <div className="hero-visual animate-fade-in" style={{ animationDelay: '0.3s' }}>
          <div className="code-window">
            <div className="window-header">
              <span className="dot red"></span>
              <span className="dot yellow"></span>
              <span className="dot green"></span>
              <span className="file-name">developer.js</span>
            </div>
            <pre className="code-content">
{`const developer = {
  name: "${name}",
  role: "${title}",
  location: "${location}",
  skills: ["Node.js", "Express", "MongoDB", "REST API"]
};

developer.code();`}
            </pre>
          </div>
        </div>
      </div>
      
      <div className="scroll-indicator">
        <div className="mouse"><div className="wheel"></div></div>
        <span>Scroll Down</span>
      </div>
    </section>
  );
};

export default Home;
